import { render, staticRenderFns } from "./FundaBNPLInsur120.vue?vue&type=template&id=af6db3b6&scoped=true&"
import script from "./FundaBNPLInsur120.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLInsur120.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLInsur120.vue?vue&type=style&index=0&id=af6db3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6db3b6",
  null
  
)

export default component.exports